import React from 'react';
import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';
import ReactMarkdown from 'react-markdown';
// import remarkGfm from 'remark-gfm';
import remarkMath from 'remark-math';
// import rehypeRaw from 'rehype-raw';
import rehypeKatex from 'rehype-katex';
import 'katex/dist/katex.min.css';

// import { cleanMarkdown } from '../../utils/commonUtils';

// Custom styles for Markdown content
const StyledMarkdown = styled(Box)(({ theme }) => ({
    '& h1': {
        ...theme.typography.h4,
        fontWeight: 'bold',
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(1),
    },
    '& h2': {
        ...theme.typography.h5,
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(1),
    },
    '& h3': {
        ...theme.typography.h6,
        marginTop: theme.spacing(1.5),
        marginBottom: theme.spacing(1),
    },
    '& p': {
        ...theme.typography.body1,
        marginBottom: theme.spacing(3),
        lineHeight: 1.6,
    },
    '& ul, & ol': {
        paddingLeft: theme.spacing(2),
    },
    '& li': {
        marginBottom: theme.spacing(1),
    },
    '& a': {
        textDecoration: 'none',
        '&:hover': {
            textDecoration: 'underline',
        },
    },
    '& blockquote': {
        paddingLeft: theme.spacing(2),
        fontStyle: 'italic',
        marginBottom: theme.spacing(1.5),
    },
    '& code': {
        padding: theme.spacing(0.5),
        fontSize: '0.875rem',
        fontFamily: 'monospace',
    },
    '& pre': {
        backgroundColor: theme.palette.grey[900],
        color: theme.palette.primary.contrastText,
        border: '1px solid',
        padding: theme.spacing(2),
        borderRadius: theme.shape.borderRadius,
        overflow: 'auto',
        fontSize: '0.875rem',
    },
    '& .katex-display': {
        margin: theme.spacing(2, 0),
    },
}));


// Markdown component
const MarkdownContent = ({ data }) => {
    // const cleanedResponse = cleanMarkdown(data);
    const cleanedResponse = data;

    return (
        <StyledMarkdown>
            <ReactMarkdown
                children={cleanedResponse}
                remarkPlugins={[remarkMath]}
                rehypePlugins={[rehypeKatex]}
            >
            </ReactMarkdown>
        </StyledMarkdown>
    );
};

export default MarkdownContent;